import React, { Fragment } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrash, faKey, faReceipt } from '@fortawesome/free-solid-svg-icons'
import '../../../../../styles/balanco.scss'

const Funcionario = (props) => {

    const deletar = async (id) => {
        props.deletar(id)
        await props.fetchFuncionarios()
    }

    const holerites = async (id) => {
        props.holerites(id)
    }

    const senha = async (id) => {
        props.senha(id)
    }
    const editar = async (id) => {
        props.editar(id)
    }
    return (
        <Fragment>
            <tr>
                <td data-label="Funcionário">{props.funcionario.nome}</td>
                <td data-label="Matrícula">{props.funcionario.matricula}</td>
                <td data-label="Cargo">{props.funcionario.cargo}</td>
                <td data-label="Situação">{props.funcionario.situacao}</td>

                {/* ---- CÉLULAS PARA DESKTOP (cada ação tem seu td) ---- */}
                <td className="acoes-desktop-cell" title="Ver Holerites" style={{ whiteSpace: "nowrap" }}>
                    <FontAwesomeIcon
                        icon={faReceipt}
                        className="mx-2 text-warning cursor-pointer"
                        onClick={() => holerites(props.funcionario._id)}
                    />
                </td>

                <td className="acoes-desktop-cell" title="Editar" style={{ whiteSpace: "nowrap" }}>
                    <FontAwesomeIcon
                        icon={faPenToSquare}
                        className="mx-2 text-warning cursor-pointer"
                        onClick={() => editar(props.funcionario._id)}
                    />
                </td>

                <td className="acoes-desktop-cell" title="Trocar Senha" style={{ whiteSpace: "nowrap" }}>
                    <FontAwesomeIcon
                        icon={faKey}
                        className="mx-2 text-warning cursor-pointer"
                        onClick={() => senha(props.funcionario._id)}
                    />
                </td>

                <td className="acoes-desktop-cell" title="Excluir" style={{ whiteSpace: "nowrap" }}>
                    <FontAwesomeIcon
                        icon={faTrash}
                        className="mx-2 text-danger cursor-pointer"
                        onClick={() => deletar(props.funcionario._id)}
                    />
                </td>

                {/* ---- CÉLULA EXTRA: GRID DE AÇÕES APENAS PARA MOBILE ----
                     Esta célula fica no DOM sempre, mas será escondida no desktop.
                     No mobile mostramos ela e escondemos as acoes-desktop-cell. */}
                <td className="acoes-mobile-cell">
                    <div className="acoes-mobile">
                        <div className="acao-item" onClick={() => holerites(props.funcionario._id)}>
                            <FontAwesomeIcon icon={faReceipt} className="acao-icon text-warning" />
                            <span>Holerites</span>
                        </div>

                        <div className="acao-item" onClick={() => editar(props.funcionario._id)}>
                            <FontAwesomeIcon icon={faPenToSquare} className="acao-icon text-warning" />
                            <span>Editar</span>
                        </div>

                        <div className="acao-item" onClick={() => senha(props.funcionario._id)}>
                            <FontAwesomeIcon icon={faKey} className="acao-icon text-warning" />
                            <span>Senha</span>
                        </div>

                        <div className="acao-item" onClick={() => deletar(props.funcionario._id)}>
                            <FontAwesomeIcon icon={faTrash} className="acao-icon text-danger" />
                            <span>Excluir</span>
                        </div>
                    </div>
                </td>
            </tr>
        </Fragment>
    )
}

export default Funcionario;
